var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "mt-0" }, [
      _vm._v("\n        " + _vm._s(_vm.$l10n.__("Unités")) + "\n    ")
    ]),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        "\n        " + _vm._s(_vm.$l10n.__("Paramétrage des unités")) + "\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "fs-3" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Ces unités sont proposées lors de la création d‘un produit ou d‘un service."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "label-input" },
      [
        _c("span", { staticClass: "fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Unité par défaut")))
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticClass: "inline",
            model: {
              value: _vm.unit,
              callback: function($$v) {
                _vm.unit = $$v
              },
              expression: "unit"
            }
          },
          _vm._l(_vm.unitList, function(unit) {
            return _c("el-option", {
              key: unit.id,
              attrs: { label: unit.value, value: parseInt(unit.id) }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__("common.actions.edit"),
            type: "tertiary",
            onclick: "Prefs.editValuesList('units');"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "label-input" },
      [
        _c("span", { staticClass: "fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Afficher l’unité dans la colonne")))
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticClass: "inline",
            model: {
              value: _vm.unitColumn,
              callback: function($$v) {
                _vm.unitColumn = $$v
              },
              expression: "unitColumn"
            }
          },
          _vm._l(_vm.unitColumnList, function(column) {
            return _c("el-option", {
              key: column.value,
              attrs: { label: column.label, value: column.value }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$l10n.__("Paramétrage des unités de mesures")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "fs-3" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Ces unités de mesure serviront pour calculer les dimensions et caractéristiques de vos produits ainsi que pour calculer les poids des colis pour les livraisons."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "label-input" },
      [
        _c("span", { staticClass: "fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Unité de mesure")))
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticClass: "inline",
            model: {
              value: _vm.dimensionUnit,
              callback: function($$v) {
                _vm.dimensionUnit = $$v
              },
              expression: "dimensionUnit"
            }
          },
          _vm._l(_vm.dimensionUnitList, function(unit) {
            return _c("el-option", {
              key: unit.value,
              attrs: { label: unit.label, value: unit.value }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "label-input" },
      [
        _c("span", { staticClass: "fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Unité de poids")))
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticClass: "inline",
            model: {
              value: _vm.weightUnit,
              callback: function($$v) {
                _vm.weightUnit = $$v
              },
              expression: "weightUnit"
            }
          },
          _vm._l(_vm.weightUnitList, function(unit) {
            return _c("el-option", {
              key: unit.value,
              attrs: { label: unit.label, value: unit.value }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("h3", [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$l10n.__("Précision de la colonne coût unitaire")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "label-input" },
      [
        _c("span", { staticClass: "fs-3" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Précision de la colonne coût unitaire")))
        ]),
        _vm._v(" "),
        _c(
          "el-select",
          {
            staticClass: "inline",
            model: {
              value: _vm.unitAmountPrecision,
              callback: function($$v) {
                _vm.unitAmountPrecision = $$v
              },
              expression: "unitAmountPrecision"
            }
          },
          _vm._l(_vm.unitAmountPrecisionList, function(precision) {
            return _c("el-option", {
              key: precision,
              attrs: { label: _vm.formatPrecision(precision), value: precision }
            })
          }),
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mt-3" },
      [
        _c("CompassButton", {
          attrs: { label: _vm.$t.__("common.actions.save") },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.save($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }